require('./overrides.scss')

export default {
  theme: {
    themes: {
      light: {
        primary: '#19AB6D',
        accent: '#2C8BDE',
        secondary: '#8A8D93',
        success: '#96D647',
        info: '#57ACE9',
        warning: '#FFCC00',
        error: '#EB3800',
      },
      dark: {
        primary: '#19AB6D',
        accent: '#2C8BDE',
        secondary: '#8A8D93',
        success: '#96D647',
        info: '#57ACE9',
        warning: '#FFCC00',
        error: '#EB3800',
      },
    },
  },
}
